import React from "react";
import {Layout} from 'antd';

const {Content} = Layout;

export default props => {

    return (
        <Content style={{
            padding: "32px 42px",
            background: "#f9fafc"}}>
            {props.children}
        </Content>
    )
}
